import { Fragment, useEffect, useState } from 'react'

import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

// removed unused SelectInterface import

interface InputProps {
  data: { name: string; id: number }[]
  label?: string
  action?: (_id: number) => void
  reset?: () => void
}

export default function SelectOrderby(props: InputProps) {
  const [selected, setSelected] = useState(props.data[0])
  if (props.action !== undefined) props.action(selected.id)

  useEffect(() => {
    return () => {
      if (typeof props.reset === 'function') {
        props.reset()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="w-72">
      <Listbox onChange={setSelected} value={selected}>
        <div className="relative mt-1">
          {props.label && (
            <Listbox.Label
              className={
                'font-mediumtext-gray-700 flex flex-shrink-0 text-sm first-letter:uppercase'
              }
            >
              <span className="inline-flex items-center">{props.label}</span>
            </Listbox.Label>
          )}
          <Listbox.Button
            className={
              'relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md ' +
              'focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2' +
              'focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm'
            }
          >
            <span className="block truncate">{selected.name}</span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon
                aria-hidden="true"
                className="h-5 w-5 text-gray-400"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options
              className={
                'absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ' +
                'shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm'
              }
            >
              {props.data.map((data) => (
                <Listbox.Option
                  className={({ active }) =>
                    'relative cursor-default select-none py-2 pl-10 pr-4 ' +
                    (active ? 'bg-amber-100 text-amber-900' : 'text-gray-900')
                  }
                  key={data.id}
                  value={data}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}
                      >
                        {data.name}
                      </span>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                          <CheckIcon aria-hidden="true" className="h-5 w-5" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  )
}
